import { MouseEventHandler } from "react";

import wrenchDark from "./wrench_24px_dark.png";
import wrenchLight from "./wrench_24px_light.png";

type WrenchIconProps = {
  color?: "light" | "dark";
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const WRENCH_IMAGES: Record<"light" | "dark", string> = {
  light: wrenchLight,
  dark: wrenchDark,
};

export const WrenchIcon = ({ color, onClick }: WrenchIconProps) => (
  <img
    src={WRENCH_IMAGES[color || "light"]}
    onClick={onClick}
    alt="Wrench icon"
  />
);
